<template>
  <div class="container">
    <div class="block">
      <p class="list-title">授课老师流失明细</p>
      <div class="total-wrap flex">
        <el-form size="mini" :model="searchInfo" inline>
          <div style="display: flex">
            <el-form-item label="查询时间">
              <el-date-picker
                v-model="searchInfo.date"
                type="monthrange"
                range-separator="至"
                start-placeholder="开始月份"
                value-format="yyyy-MM"
                end-placeholder="结束月份"
                @change="searchDateChange"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="授课老师:">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :jobIds="[1]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
            <div class="export">
              <el-button
                class="mwow-button-filled primary export-btn"
                @click="handleExport"
              >
                导出
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>

    <div style="min-height: 210px">
      <el-table
        :data="tableData"
        v-horizontal-scroll
        stripe
        style="width: 100%"
        @sort-change="handleSortChange"
        :default-sort="{
          order: 'descending',
          prop: 'transform_amount',
        }"
      >
        <el-table-column prop="staff.name" label="授课教师" fixed>
        </el-table-column>
        <el-table-column
          prop="begin_month_student_count"
          min-width="150"
          label="月初在读学员数"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            月初在读学员数
            <el-tooltip effect="dark" placement="top">
              <div slot="content">查询时间的第一天00:00绑定的在读学员数</div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{ scope.row.begin_month_student_count }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="begin_year_student_count"
          min-width="150"
          label="年初在读学员数"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            年初在读学员数
            <el-tooltip effect="dark" placement="top">
              <div slot="content">查询时间年初第一天00:00绑定的在读学员数</div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{ scope.row.begin_year_student_count }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="new_student_count"
          min-width="135"
          label="新增学员数"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            新增学员数
            <el-tooltip effect="dark" placement="top">
              <div slot="content">新增绑定的学员数</div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{ scope.row.new_student_count }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="year_begin_student_turnover_count"
          label="年初学员流失数"
          min-width="150"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            年初学员流失数
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                授课教师年初绑定的学员，在查询时间内流失的学员数
              </div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{ scope.row.year_begin_student_turnover_count }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="year_new_student_turnover_count"
          label="本年新签学员流失数"
          min-width="175"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            本年新签学员流失数
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                授课教师本年新绑定的学员，在查询时间内流失的学员数
              </div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{ scope.row.year_new_student_turnover_count }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="student_turnover_count"
          label="流失学员数"
          min-width="140"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            流失学员数
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                查询时间内，授课老师解绑的学员数，当同一个学员在查询时间内解绑2次，解绑学员数为2个
              </div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{ scope.row.student_turnover_count }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="year_begin_student_turnover_rate"
          label="年初学员流失率"
          min-width="150"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            年初学员流失率
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                年初学员流失率=年初学员流失数/年初在读学员数*100%
              </div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{
                scope.row.year_begin_student_turnover_rate === "0.00"
                  ? "0"
                  : scope.row.year_begin_student_turnover_rate
              }}%
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="year_new_student_turnover_rate"
          label="本年新增学员流失率"
          min-width="175"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            本年新增学员流失率
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                授课老师本年新增学员流失率=授课老师本年新增绑定学员的流失数/授课老师本年新增绑定的学员数*100%
              </div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{
                scope.row.year_new_student_turnover_rate === "0.00"
                  ? "0"
                  : scope.row.year_new_student_turnover_rate
              }}%
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="turnover_total_rate"
          label="流失率"
          min-width="130"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            流失率
            <el-tooltip effect="dark" placement="top">
              <div slot="content">流失率=手动流失率+结课流失率+结业流失率</div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{
                scope.row.turnover_total_rate === "0.00"
                  ? "0"
                  : scope.row.turnover_total_rate
              }}%
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="manual_turnover_rate"
          label="手动流失率"
          min-width="140"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            手动流失率
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                手动变更学员的流失学员数/应留学员数（月初在读学员数+新增学员数）*100%
              </div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{
                scope.row.manual_turnover_rate === "0.00"
                  ? "0"
                  : scope.row.manual_turnover_rate
              }}%
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="course_complete_turnover_rate"
          label="结课流失率"
          min-width="140"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            结课流失率
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                结课的流失学员数/应留学员数（月初在读学员数+新增学员数）*100%
              </div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{
                scope.row.course_complete_turnover_rate === "0.00"
                  ? "0"
                  : scope.row.course_complete_turnover_rate
              }}%
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="graduation_turnover_rate"
          label="结业流失率"
          min-width="140"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot="header">
            结业流失率
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                结业的流失学员数/应留学员数（月初在读学员数+新增学员数）*100%
              </div>
              <span
                ><i
                  class="el-icon-question"
                  style="
                    margin-left: 2px;
                    color: #bebfc0;
                    font-size: 16px;
                    vertical-align: text-bottom;
                  "
                ></i
              ></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div>
              {{
                scope.row.graduation_turnover_rate === "0.00"
                  ? "0"
                  : scope.row.graduation_turnover_rate
              }}%
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getTeacherTurnoverApi } from "@/api/statistics";
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import json2csv from "json2csv";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
export default {
  components: {
    commonStaffPullDown,
  },
  data() {
    return {
      tableData: [],
      timeDate: [],
      currentSortOption: {
        order: "descending",
        prop: "",
      },
      searchInfo: {
        date: [],
        teacher_id: 0,
        timeDate: [],
        range: "month",
      },
      exporting: false,
    };
  },
  props: ["timeYearDate"],
  watch: {
    timeYearDate: {
      handler() {
        this.searchRangeChange();
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    this.searchRangeChange();
  },
  methods: {
    handleSearch() {
      this.getList(this.timeDate[0], this.timeDate[1]);
    },
    getList(start, end) {
      getTeacherTurnoverApi({
        start_date: start,
        end_date: end,
        teacher_id: this.searchInfo.teacher_id ? this.searchInfo.teacher_id : 0,
      }).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map(() => {});
          this.tableData = res.data.list;
        }
      });
    },
    handleSortChange(val) {
      this.currentSortOption = {
        order: val.order,
        prop: val.prop,
      };
      this.tableData = this.sortList(this.tableData);
      let n = 0;
      this.tableData.map((it) => {
        n += 1;
        it.ranking = n;
      });
    },
    sortList(val) {
      const copy = [...val];
      copy.sort((a, b) => {
        return (
          Number(b[this.currentSortOption.prop]) -
          Number(a[this.currentSortOption.prop])
        );
      });
      copy.map((it, ind) => {
        it.ind = ind + 1;
      });
      if (this.currentSortOption.order === "ascending") {
        copy.reverse();
      }
      return copy;
    },
    searchDateChange() {
      const monthStartArr = getCurrentMonth(this.searchInfo.date[0]);
      const monthEndArr = getCurrentMonth(this.searchInfo.date[1]);
      const start = dateFormat("YYYY-mm-dd", monthStartArr[0]);
      const end = dateFormat("YYYY-mm-dd", monthEndArr[1]);
      this.timeDate[0] = start;
      this.timeDate[1] = end;
      this.getList(start, end);
    },
    searchRangeChange() {
      let start = "";
      let end = "";
      const now = new Date();
      let year;
      if (this.timeYearDate === "") {
        year = now.getFullYear();
      } else {
        year = this.timeYearDate;
      }
      start = dateFormat("YYYY-mm-dd", new Date(year, 0, 1).toISOString());
      end = dateFormat("YYYY-mm-dd", new Date(year, 11, 31).toISOString());
      this.timeDate = [start, end];
      this.searchInfo.date = [start, end];
      this.getList(start, end);
    },
    // 导出
    handleExport() {
      if (this.exporting) {
        return false;
      }
      this.exporting = true;
      const date = new Date().getTime();
      const dateTime = dateFormat("YYYYmmddHHMMSS", date);
      const endThree = String(date).slice(-3, date.length);
      const newExportData = JSON.parse(JSON.stringify(this.tableData));
      try {
        const result = json2csv.parse(
          [
            {
              "staff.name": "授课教师",
              begin_month_student_count: "月初在读学员数",
              begin_year_student_count: "年初在读学员数",
              new_student_count: "新增学员数",
              year_begin_student_turnover_count: "年初学员流失数",
              year_new_student_turnover_count: "本年新签学员流失数",
              student_turnover_count: "流失学员数",
              year_begin_student_turnover_rate: "年初学员流失率",
              year_new_student_turnover_rate: "本年新增学员流失率",
              turnover_total_rate: "流失率",
              manual_turnover_rate: "手动流失率",
              course_complete_turnover_rate: "结课流失率",
              graduation_turnover_rate: "结业流失率",
            },
            ...newExportData,
          ],
          {
            fields: [
              "staff.name",
              "begin_month_student_count",
              "begin_year_student_count",
              "new_student_count",
              "year_begin_student_turnover_count",
              "year_new_student_turnover_count",
              "student_turnover_count",
              "year_begin_student_turnover_rate",
              "year_new_student_turnover_rate",
              "turnover_total_rate",
              "manual_turnover_rate",
              "course_complete_turnover_rate",
              "graduation_turnover_rate",
            ],
            header: false,
          }
        );
        // 非IE浏览器
        const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
        // 创建a标签下载
        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = "授课教师流失明细" + dateTime + endThree;
        (".csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // 3秒导出间隔
        setTimeout(() => {
          this.exporting = false;
        }, 3000);
        this.$message({
          message: "导出成功",
          type: "success",
        });
      } catch (err) {
        this.$message({
          type: "error",
          message: err.toString(),
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  border-radius: 4px;
  position: relative;
  .btn-right {
    position: absolute;
    right: 10px;
    top: -40px;
    z-index: 999;
  }
  .selfheader {
    display: flex;
    align-items: center;
    text-align: center;
    padding-bottom: 15px;
    .question {
      margin-left: 5px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: #bebfc0;
      text-align: center;
      line-height: 16px;
      opacity: 1;
      color: #fff;
      font-size: 10px;
    }
  }
}
.list-title {
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 14px;
  color: #5c5d5e;
  font-weight: bold;
}
</style>
